import * as Sentry from '@sentry/nextjs'

type TOptions = FirstParam<typeof Sentry.init>

const defaultInitOptions: TOptions = {
  dsn: '',
  tracesSampleRate: 0.2,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
}

export const initSentry = (initOptions: TOptions) => {
  // if there is no DSN (data source name), do not init Sentry
  if (!initOptions.dsn && !defaultInitOptions.dsn) {
    return
  }

  return Sentry.init({ ...defaultInitOptions, ...initOptions })
}
